import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TableLazyLoadEvent } from 'primeng/table';
import { MonitoringFile, MonitoringFiles } from '../../models';
import { MonitoringService } from '../../services/monitoring.service';

@Component({
  standalone: false,
  selector: 'app-import',
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.scss',
})
export class MonitoringComponent {
  private readonly router: Router = inject(Router);
  private readonly monitoringService: MonitoringService =
    inject(MonitoringService);
  importFiles: MonitoringFiles | null = null;
  loading: boolean = true;
  pageSize: number = 200;
  first: number = 0;
  rowsPerPageOptions: number[] = [200, 500, 1000];
  // Propriétés pour le dialog
  displayDialog: boolean = false;
  selectedFileId: number | null = null;
  selectedFileName: string = '';

  // Getter pour générer dynamiquement le tableau pour le skeleton loading
  get loadingArray(): number[] {
    return Array(this.pageSize)
      .fill(0)
      .map((_, i) => i);
  }

  loadData(event: TableLazyLoadEvent): void {
    this.loading = true;
    const first = event.first ?? 0;
    this.pageSize = event.rows ?? this.pageSize;

    // Calculer la page correctement pour l'API
    const page = Math.floor(first / this.pageSize) + 1;

    // Mettre à jour la propriété first pour la synchronisation avec PrimeNG
    this.first = first;

    this.monitoringService.getPaginatedFiles(page, this.pageSize).subscribe({
      next: (data: MonitoringFiles) => {
        // Adaptation format de sortie pour correspondre au modèle ImportItems
        this.importFiles = data;
        this.loading = false;
      },
      error: (error: unknown) => {
        console.error('Monitoring - Error while loading data:', error);
        this.loading = false;
      },
    });
  }

  selectRow(data: MonitoringFile): void {
    this.router.navigate([`monitoring/${data.id}`], {
      state: {
        fileName: data.nomOriginalFichier,
      },
    });
  }

  showFile(data: MonitoringFile): void {
    this.selectedFileId = data.id;
    this.selectedFileName = data.nomOriginalFichier;
    this.displayDialog = true;
  }
}
